import { requestOrThrow } from '../api-client'
import type {
  Order,
  OrderByToken,
  OrderSearchCondition,
  SearchedOrder,
} from '../order'

export function searchOrders(condition?: OrderSearchCondition, targetGroupMemberId?: number) {
  return requestOrThrow<SearchedOrder>('orders', {
    query: {
      ...condition,
      status: 'waiting',
      // 会計依頼一覧は医院発行の会計のみを表示する。顧客発行の簡易会計(中断で waiting のまま
      // 残ったものを含む)は除外する。proxy_group_member_id は serializer の無条件属性なので、
      // exclude でも対象者(本人/メンバー)バッジは取得できる。
      issuedUserData: 'exclude',
      // index は単一 target スコープ。未指定=操作者自身。本人+メンバー分は呼び出し側が
      // target ごとに取得してマージする。
      ...(targetGroupMemberId != null ? { targetGroupMemberId } : {}),
    },
  })
}

export function getOrderDetail(id: number, targetGroupMemberId?: number) {
  return requestOrThrow<Order>(`orders/${id}`, {
    query: {
      status: 'waiting',
      // 代理操作の宛先。未指定=操作者自身。宛先不一致は 403(E_ACCOUNT_MISMATCH)/汎用ガードは plain 403。
      ...(targetGroupMemberId != null ? { targetGroupMemberId } : {}),
    },
  })
}

// 会計URLのトークンで未所有/既所有を問わず表示専用に取得する(orders#token_show・所有者不問)。
// 新規患者(glen未リンク)が対象者を選ぶ前でも会計情報を表示できる。
export function getOrderByToken(orderId: number, orderLinkToken: string) {
  return requestOrThrow<OrderByToken>(`orders/${orderId}/token`, {
    headers: {
      'X-LINK-TOKEN': orderLinkToken,
    },
  })
}

export function getOrderAttachedFile(orderId: number, targetGroupMemberId?: number) {
  return requestOrThrow<Blob>(`orders/${orderId}/attached_file`, {
    responseType: 'blob',
    skipConvertKeyRecursivelyOnResponse: true,
    // メンバー所有の会計の添付は宛先指定が必要(未指定だと 404)。
    query: targetGroupMemberId != null ? { targetGroupMemberId } : {},
  })
}

// 会計URLのトークンで添付資料を取得する(所有者不問・token_show と同認可)。
// 新規患者(glen未リンク)が対象者を選ぶ前=未所有でも、所有者スコープ取得のように 404 にならない。
export function getOrderAttachedFileByToken(orderId: number, orderLinkToken: string) {
  return requestOrThrow<Blob>(`orders/${orderId}/token/attached_file`, {
    responseType: 'blob',
    skipConvertKeyRecursivelyOnResponse: true,
    headers: {
      'X-LINK-TOKEN': orderLinkToken,
    },
  })
}

export function getOrderReceiptFile(orderId: number, targetGroupMemberId?: number) {
  return requestOrThrow<Blob>(`orders/${orderId}/receipt_file`, {
    responseType: 'blob',
    skipConvertKeyRecursivelyOnResponse: true,
    // メンバー所有の会計の領収書は宛先指定が必要(未指定だと 404)。
    query: targetGroupMemberId != null ? { targetGroupMemberId } : {},
  })
}

export function linkOrder(orderId: number, linkToken: string, targetGroupMemberId?: number) {
  return requestOrThrow<Order>(`orders/${orderId}/link`, {
    method: 'POST',
    headers: {
      'X-LINK-TOKEN': linkToken,
    },
    query: {
      // 紐付け先(対象者)の pgm id。未指定=操作者自身。
      ...(targetGroupMemberId != null ? { targetGroupMemberId } : {}),
    },
  })
}
